import { defineComponent as r, openBlock as l, createBlock as a, unref as p, mergeProps as d, withCtx as u, createElementVNode as o } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconSoundLow",
  __name: "IconSoundLow",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (i, e) => (l(), a(p(c), d(t, { "view-box": "0 0 24 24" }), {
      default: u(() => [...e[0] || (e[0] = [
        o("path", {
          "fill-rule": "evenodd",
          d: "M14 5.062c0-1.058-1.231-1.637-2.046-.964L8.744 6.75H7.25A3.25 3.25 0 0 0 4 10v4a3.25 3.25 0 0 0 3.25 3.25h1.493l3.21 2.652C12.77 20.576 14 19.996 14 18.938V5.062M9.63 7.964l2.87-2.372v12.816l-2.87-2.372a1.25 1.25 0 0 0-.797-.286H7.25A1.75 1.75 0 0 1 5.5 14v-4a1.75 1.75 0 0 1 1.75-1.75h1.583A1.25 1.25 0 0 0 9.63 7.964",
          "clip-rule": "evenodd"
        }, null, -1),
        o("path", { d: "M16.466 8.103a.75.75 0 1 0-.858 1.23A3.25 3.25 0 0 1 17 12a3.25 3.25 0 0 1-1.392 2.667.75.75 0 0 0 .858 1.23A4.75 4.75 0 0 0 18.5 12a4.75 4.75 0 0 0-2.034-3.897" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
